import React from 'react';
import PropTypes from 'prop-types';

import Button from '~/components/core/Atomic/Buttons/Button';
import cn from '~/Utils/cn';

import styles from './ActionMenuButton.module.scss';

export default function ActionMenuButton({ onClick, label, IconComponent = null, disabled = false, adornment = null }) {
  const Icon = IconComponent ? <IconComponent className={styles.icon} size={20} /> : null;

  return (
    <Button
      onClick={onClick}
      classes={{
        // v5 deleted the `label` slot, whose span wrapped the icon and the text alike, so the
        // disabled/enabled typography folds into the root. `.disabled`/`.enabled` moved from
        // descendants of `.actionsMenuButton` to `&.`-compounds in the stylesheet to match.
        root: cn(styles.actionsMenuButton, styles.root, disabled ? styles.disabled : styles.enabled),
        startIcon: !disabled && styles.icon,
      }}
      disabled={disabled}
      disableRipple
      startIcon={Icon}
    >
      {label}
      {adornment}
    </Button>
  );
}

ActionMenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  IconComponent: PropTypes.elementType,
  disabled: PropTypes.bool,
  adornment: PropTypes.node,
};
